<script lang="ts" setup>
import TeamCarousel from '~/components/workshop/team-carousel.vue'
import Swoosh from '~/assets/swoosh.svg?component'
import type {WorkshopTeam} from '~/types/workshop'

const props = defineProps<{
  data: Exclude<WorkshopTeam, undefined | null>
}>()
</script>

<template>
  <Container class="screen-content flex flex-col items-center space-y-6 pb-16 pt-32 text-center md:pb-16 lg:pb-16">
    <Heading as="h2" class="w-full lg:w-1/2" size="large">{{ data.title }}</Heading>
    <div class="flex w-full flex-col items-center justify-center pb-16 lg:w-1/2">
      <RichText v-if="data.description" :raw="data.description" />
      <Swoosh class="mt-4" />
    </div>

    <TeamCarousel :first="false" :items="data.imageGrid || []" />
    <TeamCarousel :first="true" :items="data.secondImageGrid || []" />
  </Container>
</template>
